import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  readonly loggedIn = new BehaviorSubject<boolean>(false);
  readonly finalAccessToken = new BehaviorSubject<string>('');
  readonly eID = new BehaviorSubject<number>(0);
  readonly tID = new BehaviorSubject<number>(0);
  readonly user_ID = new BehaviorSubject<number>(0);

  get isLoggedIn(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  login(value: boolean) : void {
    this.loggedIn.next(value);
  }

  logout() : void {
    this.loggedIn.next(false);
  }

  getAccessToken(): any {
    if(this.finalAccessToken.getValue() !== ''){
      return this.finalAccessToken.getValue()
    }
      return this.finalAccessToken.getValue()
  }

  isAuthenticated(): boolean {
    return this.getAccessToken() !== '';
  }

  saveUserDetails(data: any): void {
    this.finalAccessToken.next(data[0].accessToken)
    this.eID.next(data[0].eId)
    this.tID.next(data[0].tId)
    this.user_ID.next(data[0].userId)
  }

  getFinalAccessToken(): Observable<string> {
    return this.finalAccessToken.asObservable();
  }

  getEID(): number{
    return this.eID.getValue()
  }

  getTID(): number {
    return this.tID.getValue()
  }
  getUserId(): number {
    return this.user_ID.getValue()
  }

  clearAccessToken(): void {
    this.finalAccessToken.next('')
    this.eID.next(0)
    this.tID.next(0)
    this.user_ID.next(0)
  }

}
